import moment from 'jalali-moment';
import React from 'react';

/*
    - ihoDesignSystem
*/
import { Badge, Box, Button, Calendar, Grid, Image, Modal, Select, TextField } from '@iho-design-system/Loader';

/*
    - icon
*/
import CalendarSVG from '../../assets/images/icons/calendar-blue.svg';
import CloseSVG from '../../assets/images/icons/close.svg';
import SearchSVG from '../../assets/images/icons/search.svg';

const Toolbar = ({ advancedSearchProps, props, reloadReserveProps, reserveIdSearchProps , onOpenAdvancedSearch }) => {

    /*
        - defaultData
    */
    const today = moment().locale('fa').format('YYYY/MM/DD');
    const [reserveFilters, setreserveFilters] = React.useState({
        reserves: [],
        cities: [],
        hotels: []
    });
    const [reserveIdSearchKey, setReserveIdSearchKey] = React.useState({
        value: '',
        color: 'dark'
    });
    const [advancedSearchKey, setAdvancedsearchKey] = React.useState({
        ReserveType: 1,
        CityId: 0,
        HotelId: 0
    });
    const [advancedSearchInsertDate, setAdvancedSearchInsertDate] = React.useState('');
    const [advancedSearchStartDate, setAdvancedSearchStartDate] = React.useState('');

    React.useEffect(() => {
        if (props.reserveFilters.status === 200) {
            setreserveFilters({
                reserves: props.reserveFilters.data.Reserves,
                cities: props.reserveFilters.data.Cities,
                hotels: props.reserveFilters.data.Hotels
            });
        }
    }, [props]);

    const [disabled, setDisabled] = React.useState(false);

    React.useEffect(() => {
            if (advancedSearchKey.ReserveType == 1 && advancedSearchKey.CityId == 0 && advancedSearchKey.HotelId == 0 && advancedSearchInsertDate === '' && advancedSearchStartDate === '') {
            setDisabled(true);
        } else {
            setDisabled(false);
        }
    }, [advancedSearchKey, advancedSearchInsertDate, advancedSearchStartDate]);

    /*
        - reserveIdSearchHandler
    */
    const reserveIdSearchHandler = (value) => {
        if ((value.length === 10 && /^[\u06F0-\u06F90-9]+$/.test(value)) || value.length === 0) {
            setReserveIdSearchKey({
                value: value,
                color: 'dark'
            });
        } else {
            setReserveIdSearchKey({
                value: value,
                color: 'danger'
            });
        }
    }

    /*
        - reserveIdSearchProps
    */
    const reserveIdSearch = () => {
        reserveIdSearchProps(reserveIdSearchKey.value)
    }

    /*
        - advancedSearchHandler
    */
    const advancedSearchHandler = (key, value) => {
        if (key === 'reserveType') {
            setAdvancedsearchKey({
                ...advancedSearchKey,
                ReserveType: value
            });
        }
        if (key === 'city') {
            setAdvancedsearchKey({
                ...advancedSearchKey,
                CityId: value
            });
        }
        if (key === 'hotel') {
            setAdvancedsearchKey({
                ...advancedSearchKey,
                HotelId: value
            });
        }
    }

    /*
        - advancedSearch
    */
    const advancedSearch = () => {
        setReserveIdSearchKey({
            value: '',
            color: 'dark'
        });
        advancedSearchKey.StartDate = (advancedSearchStartDate !== '') ? moment.from(advancedSearchStartDate, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD') : '';
        advancedSearchKey.InsertDate = (advancedSearchInsertDate !== '') ? moment.from(advancedSearchInsertDate, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD') : '';
        advancedSearchProps(advancedSearchKey);
        closeModal('searchModal');
    }

    /*
        - clearDate
    */
    const clearDate = (calendar) => {
        if (calendar === 'advancedSearchStartDate' || calendar === 'advancedSearchStartDateMobile') {
            setAdvancedSearchStartDate('');
        }
        if (calendar === 'advancedSearchInsertDate' || calendar === 'advancedSearchInsertDateMobile') {
            setAdvancedSearchInsertDate('');
        }
    }

    /*
        - unsetFilter
    */
    const unsetFilter = () => {
        setReserveIdSearchKey({
            value: '',
            color: 'dark'
        });
        setAdvancedsearchKey({
            ReserveType: 1,
            CityId: 0,
            HotelId: 0
        });
        setAdvancedSearchInsertDate('');
        setAdvancedSearchStartDate('');
        closeModal('searchModal');
        reloadReserveProps(Math.floor(Math.random() * 100));
    }

    /*
        - searchBoxToggle
    */
    const searchBoxToggle = (event) => {
        let slideUp = event.target.closest('.parent-class').querySelector('.slide-up');
        let slideDown = event.target.closest('.parent-class').querySelector('.slide-down');
        // document.querySelector('.unsetFilter').classList.toggle('d-block');
        if (slideUp) {
            slideUp.classList.add(`slide-down`);
            slideUp.classList.remove(`slide-up`);
        } else {
            slideDown.classList.add(`slide-up`);
            slideDown.classList.remove(`slide-down`);
        }
    }

    /*
        - modal
    */
    const openModal = (modal) => {
        document.querySelector(`.${modal}`).classList.remove('d-none');
    }

    const closeModal = (modal) => {
        document.querySelector(`.${modal}`).classList.add('d-none');
    }

    /*
        - toggleCaldendar
    */
    const toggleCalendar = (event, calendar) => {
        if (event.target.tagName === 'DIV' || event.target.tagName === 'INPUT') {
            document.querySelector(`.${calendar}`).classList.toggle('d-none');
        }
    }

    /*
        - scale
    */
    const screenWidth = window.innerWidth;
    let scale = '';
    if (screenWidth > 1400) {
        scale = 'xx-large';
    } else if (screenWidth <= 1400 && screenWidth > 1200) {
        scale = 'x-large';
    } else if (screenWidth <= 1200 && screenWidth > 992) {
        scale = 'large'
    } else if (screenWidth <= 992 && screenWidth > 768) {
        scale = 'medium'
    } else if (screenWidth <= 768 && screenWidth > 576) {
        scale = 'small'
    } else if (screenWidth <= 576) {
        scale = 'x-small'
    }

    return (
        <React.Fragment>
            <Box
                className={`parent-class`}>
                <Grid>
                    <Grid.Wrapper>
                        <Grid.Item
                            className={`position-relative`}
                            size='col-8 md-4'>
                            <TextField
                                onChange={reserveIdSearchHandler}
                                color={reserveIdSearchKey.color}
                                placeholder='جستجو براساس کد پیگیری رزرو'
                                value={reserveIdSearchKey.value} />
                            {reserveIdSearchKey.color === 'dark' &&
                                <Button
                                    onClick={reserveIdSearch}
                                    variant='light'
                                    color='primary'
                                    size='sm'
                                    ms={{
                                        position: 'absolute',
                                        top: '12px',
                                        left: '12px',
                                    }}>
                                    <Image
                                        src={SearchSVG} />
                                </Button>
                            }
                            {reserveIdSearchKey.color === 'danger' &&
                                <Button
                                    variant='light'
                                    color='danger'
                                    size='sm'
                                    ms={{
                                        position: 'absolute',
                                        top: '12px',
                                        left: '12px',
                                    }}>
                                    <Image
                                        src={SearchSVG} />
                                </Button>
                            }
                        </Grid.Item>
                        <Grid.Item
                            className={`text-left`}
                            size='col-4 md-8'>
                            {(scale === 'xx-large' || scale === 'x-large' || scale === 'large' || scale === 'medium' || scale === 'small') &&
                                <React.Fragment>
                                    <Button
                                        onClick={unsetFilter}
                                        disabled = {disabled}
                                        className={`unsetFilter mx-sm mr-0`}
                                        color='danger'>
                                        حذف فیلترها
                                    </Button>
                                    <Button
                                            onClick={(event) => {
                                                onOpenAdvancedSearch();
                                                searchBoxToggle(event);
                                            }}
                                        color='primary'>
                                        جستجوی پیشرفته
                                    </Button>
                                </React.Fragment>
                            }
                            {(scale === 'x-small' || scale === 'x-small') &&
                                <Button
                                onClick={() => {
                                    onOpenAdvancedSearch();
                                    openModal('searchModal');
                                }}
                                    className={`w-100`}
                                    color='primary'>
                                    فیلترها
                                </Button>
                            }
                        </Grid.Item>
                    </Grid.Wrapper>
                </Grid>
                <Grid>
                    <Grid.Wrapper
                        className={`slide-up`}>
                        <Grid.Item
                            size='col-4 lg-2'>
                            <Select
                                onChange={(value) => advancedSearchHandler('reserveType', value)}
                                label='وضعیت رزرو'
                                init={advancedSearchKey.ReserveType}
                                readonly>
                                <Select.Item
                                    value='1'>
                                    کل رزروها
                                </Select.Item>
                                <Select.Item
                                    value='2'>
                                    رزروهای قطعی
                                </Select.Item>
                                <Select.Item
                                    value='3'>
                                    رزروهای کنسل شده
                                </Select.Item>
                                <Select.Item
                                    value='4'>
                                    رزروهای اتمام مهلت
                                </Select.Item>
                                <Select.Item
                                    value='5'>
                                    رزروهای آماده پرداخت
                                </Select.Item>
                                <Select.Item
                                    value='6'>
                                    رزروهای اخیر
                                </Select.Item>
                                <Select.Item
                                    value='7'>
                                    سایر وضعیت ها
                                </Select.Item>
                            </Select>
                        </Grid.Item>
                        <Grid.Item
                            size='col-4 lg-2'>
                            <Select
                                onChange={(value) => advancedSearchHandler('city', value)}
                                label='شهرها'
                                init={advancedSearchKey.CityId}
                                search
                                readonly>
                                <Select.Item
                                    value='0'>
                                    کل شهرها
                                </Select.Item>
                                {reserveFilters.cities.map((obj, index) => {
                                    if (obj.Count !== 0) {
                                        return (
                                            <Select.Item
                                                key={index}
                                                value={obj.Id}>
                                                {obj.Name}
                                                &nbsp;
                                                <Badge
                                                    color='primary'>
                                                    {obj.Count}
                                                    &nbsp;
                                                    رزرو
                                                </Badge>
                                            </Select.Item>
                                        )
                                    }
                                    return null;
                                })}
                            </Select>
                        </Grid.Item>
                        <Grid.Item
                            size='col-4 lg-3'>
                            <Select
                                onChange={(value) => advancedSearchHandler('hotel', value)}
                                label='هتل‌ها'
                                init={advancedSearchKey.HotelId}
                                search
                                readonly>
                                <Select.Item
                                    value='0'>
                                    کل هتل‌ها
                                </Select.Item>
                                {reserveFilters.hotels.map((obj, index) => {
                                    if (obj.Count !== 0) {
                                        return (
                                            <Select.Item
                                                key={index}
                                                value={obj.Id}>
                                                {obj.Name}
                                                &nbsp;
                                                <Badge
                                                    color='primary'>
                                                    {obj.Count}
                                                    &nbsp;
                                                    رزرو
                                                </Badge>
                                            </Select.Item>
                                        )
                                    }
                                    return null;
                                })}
                            </Select>
                        </Grid.Item>
                        <Grid.Item
                            className={`position-relative`}
                            size='col-4 lg-2'>
                            <Box
                                onClick={(event) => toggleCalendar(event, 'advancedSearchInsertDate')}>
                                <TextField
                                    label='ثبت رزرو'
                                    value={advancedSearchInsertDate}
                                    placeholder='روز/ماه/سال'
                                    ms={{
                                        'input': {
                                            paddingRight: '35px'
                                        }
                                    }} />
                                <Image
                                    className={`pointer position-absolute`}
                                    src={CalendarSVG}
                                    ms={{
                                        width: '16px',
                                        height: '16px',
                                        top: '47px',
                                        right: '20px'
                                    }} />
                                {advancedSearchInsertDate !== '' &&
                                    <Image
                                        onClick={() => clearDate('advancedSearchInsertDate')}
                                        className={`pointer position-absolute`}
                                        src={CloseSVG}
                                        ms={{
                                            width: '16px',
                                            height: '16px',
                                            top: '47px',
                                            left: '20px'
                                        }} />
                                }
                                <Box
                                    className={`advancedSearchInsertDate d-none position-absolute`}
                                    ms={{
                                        width: '100%',
                                        top: 'calc(75px + var(--sizing-xs))',
                                        zIndex: '1'
                                    }}>
                                    <Calendar
                                        onChange={(event) => setAdvancedSearchInsertDate(event)}
                                        maxDate={today} />
                                </Box>
                            </Box>
                        </Grid.Item>
                        <Grid.Item
                            className={`position-relative`}
                            size='col-4 lg-2'>
                            <Box
                                onClick={(event) => toggleCalendar(event, 'advancedSearchStartDate')}>
                                <TextField
                                    label='ورود به هتل'
                                    value={advancedSearchStartDate}
                                    placeholder='روز/ماه/سال'
                                    ms={{
                                        'input': {
                                            paddingRight: '35px'
                                        }
                                    }} />
                                <Image
                                    className={`pointer position-absolute`}
                                    src={CalendarSVG}
                                    ms={{
                                        width: '16px',
                                        height: '16px',
                                        top: '47px',
                                        right: '20px'
                                    }} />
                                {advancedSearchStartDate !== '' &&
                                    <Image
                                        onClick={() => clearDate('advancedSearchStartDate')}
                                        className={`pointer position-absolute`}
                                        src={CloseSVG}
                                        ms={{
                                            width: '16px',
                                            height: '16px',
                                            top: '47px',
                                            left: '20px'
                                        }} />
                                }
                                <Box
                                    className={`advancedSearchStartDate d-none position-absolute`}
                                    ms={{
                                        width: '100%',
                                        top: 'calc(75px + var(--sizing-xs))',
                                        zIndex: '1'
                                    }}>
                                    <Calendar
                                        onChange={(event) => setAdvancedSearchStartDate(event)} />
                                </Box>
                            </Box>
                        </Grid.Item>
                        <Grid.Item
                            size='col-4 lg-1'>
                            <Button
                                onClick={advancedSearch}
                                className={`w-100`}
                                variant='filled'
                                color='primary'
                                ms={{
                                    marginTop: '28px'
                                }}>
                                جستجو
                            </Button>
                        </Grid.Item>
                    </Grid.Wrapper>
                </Grid>
            </Box>
            <Modal
                className={`searchModal`}>
                <Modal.Wrapper
                    size='xs'
                    ms={{
                        '@media(min-width:576px)': {
                            width: '360px !important'
                        },
                        '@media(max-width:576px)': {
                            width: 'calc(100% - 12px) !important'
                        }
                    }}>
                    <Modal.Header>
                        <Box />
                    </Modal.Header>
                    <Grid>
                        <Grid.Wrapper>
                            <Grid.Item
                                size='col-12'>
                                <Select
                                    onChange={(value) => advancedSearchHandler('reserveType', value)}
                                    placeholder='وضعیت رزرو'
                                    readonly>
                                    <Select.Item
                                        value='1'>
                                        کل رزروها
                                    </Select.Item>
                                    <Select.Item
                                        value='2'>
                                        رزروهای قطعی
                                    </Select.Item>
                                    <Select.Item
                                        value='3'>
                                        رزروهای کنسل شده
                                    </Select.Item>
                                    <Select.Item
                                        value='4'>
                                        رزروهای اتمام مهلت
                                    </Select.Item>
                                    <Select.Item
                                        value='5'>
                                        رزروهای آماده پرداخت
                                    </Select.Item>
                                    <Select.Item
                                        value='6'>
                                        رزروهای اخیر
                                    </Select.Item>
                                    <Select.Item
                                        value='7'>
                                        سایر وضعیت ها
                                    </Select.Item>
                                </Select>
                            </Grid.Item>
                            <Grid.Item
                                size='col-12'>
                                <Select
                                    onChange={(value) => advancedSearchHandler('city', value)}
                                    placeholder='شهرها'
                                    search
                                    readonly>
                                    <Select.Item
                                        value='0'>
                                        همه
                                    </Select.Item>
                                    {reserveFilters.cities.map((obj, index) => {
                                        if (obj.Count !== 0) {
                                            return (
                                                <Select.Item
                                                    key={index}
                                                    value={obj.Id}>
                                                    {obj.Name}
                                                    &nbsp;
                                                    <Badge
                                                        color='primary'>
                                                        {obj.Count}
                                                        &nbsp;
                                                        رزرو
                                                    </Badge>
                                                </Select.Item>
                                            )
                                        }
                                        return null;
                                    })}
                                </Select>
                            </Grid.Item>
                            <Grid.Item
                                size='col-12'>
                                <Select
                                    onChange={(value) => advancedSearchHandler('hotel', value)}
                                    placeholder='هتل‌ها'
                                    search
                                    readonly>
                                    <Select.Item
                                        value='0'>
                                        همه
                                    </Select.Item>
                                    {reserveFilters.hotels.map((obj, index) => {
                                        if (obj.Count !== 0) {
                                            return (
                                                <Select.Item
                                                    key={index}
                                                    value={obj.Id}>
                                                    {obj.Name}
                                                    &nbsp;
                                                    <Badge
                                                        color='primary'>
                                                        {obj.Count}
                                                        &nbsp;
                                                        رزرو
                                                    </Badge>
                                                </Select.Item>
                                            )
                                        }
                                        return null;
                                    })}
                                </Select>
                            </Grid.Item>
                            <Grid.Item
                                className={`position-relative`}
                                size='col-12'>
                                <Box
                                    onClick={(event) => toggleCalendar(event, 'advancedSearchInsertDateMobile')}>
                                    <TextField
                                        icon={CalendarSVG}
                                        value={advancedSearchInsertDate}
                                        placeholder='ثبت رزرو (روز/ماه/سال)' />
                                    {advancedSearchInsertDate !== '' &&
                                        <Image
                                            onClick={() => clearDate('advancedSearchInsertDateMobile')}
                                            className={`pointer position-absolute`}
                                            src={CloseSVG}
                                            ms={{
                                                width: '16px',
                                                height: '16px',
                                                top: '20px',
                                                left: '40px'
                                            }} />
                                    }
                                    <Box
                                        className={`advancedSearchInsertDateMobile d-none position-absolute`}
                                        ms={{
                                            width: '100%',
                                            transform: 'translate(-50%, -50%)',
                                            top: '50%',
                                            left: '50%',
                                            zIndex: '1'
                                        }}>
                                        <Calendar
                                            onChange={(event) => setAdvancedSearchInsertDate(event)}
                                            maxDate={today} />
                                    </Box>
                                </Box>
                            </Grid.Item>
                            <Grid.Item
                                className={`position-relative`}
                                size='col-12'>
                                <Box
                                    onClick={(event) => toggleCalendar(event, 'advancedSearchStartDateMobile')}>
                                    <TextField
                                        icon={CalendarSVG}
                                        value={advancedSearchStartDate}
                                        placeholder='ورود به هتل (روز/ماه/سال)' />
                                    {advancedSearchStartDate !== '' &&
                                        <Image
                                            onClick={() => clearDate('advancedSearchStartDateMobile')}
                                            className={`pointer position-absolute`}
                                            src={CloseSVG}
                                            ms={{
                                                width: '16px',
                                                height: '16px',
                                                top: '20px',
                                                left: '40px'
                                            }} />
                                    }
                                    <Box
                                        className={`advancedSearchStartDateMobile d-none position-absolute`}
                                        ms={{
                                            width: '100%',
                                            transform: 'translate(-50%, -50%)',
                                            top: '50%',
                                            left: '50%',
                                            zIndex: '1'
                                        }}>
                                        <Calendar
                                            onChange={(event) => setAdvancedSearchStartDate(event)} />
                                    </Box>
                                </Box>
                            </Grid.Item>
                            <Grid.Item
                                size='col-7'>
                                <Button
                                    onClick={advancedSearch}
                                    className={`w-100`}
                                    variant='filled'
                                    color='primary'>
                                    جستجو
                                </Button>
                            </Grid.Item>
                            <Grid.Item
                                size='col-5'>
                                <Button
                                    onClick={unsetFilter}
                                    className={`w-100`}
                                    variant='outlined'
                                    color='danger'>
                                    حذف فیلترها
                                </Button>
                            </Grid.Item>
                        </Grid.Wrapper>
                    </Grid>
                </Modal.Wrapper>
            </Modal>
        </React.Fragment >
    );

}

export default Toolbar;